'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useRequiredI18nProps, getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { FormFieldContext } from '../form/form.context.js';
import { Card } from '../card/card.component.js';
import { Spinner } from '../spinner/spinner.component.js';
import { FormError } from '../form/form-error.component.js';
import { Progress } from '../progress-bar/progress.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { Typography } from '../typography/typography.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const FileTile = renderWithRef('FileTile', null, (n, y)=>{
    let w = useInternalOptionalSwanI18nContext();
    useRequiredI18nProps(n, [
        'accessibleTextForProgress',
        'accessibleTextForSpinner'
    ]), useDeprecatedProps('FileTile', n, [
        {
            propName: 'accessibleTextForProgress',
            instructions: getDeprecatedI18nPropMessage(w)
        },
        {
            propName: 'accessibleTextForSpinner',
            instructions: getDeprecatedI18nPropMessage(w)
        }
    ]), useComponentStylesLoaded('FileTile', SWAN_STYLE_KEY_MAP.fileTile);
    let { children: O, fileName: j, fileDescription: _, progressValue: g, accessibleTextForProgress: h, accessibleTextForSpinner: x, skin: P = 'standard', layout: F = 'thumb', errorMessage: v } = n, T = _object_without_properties(n, [
        "children",
        "fileName",
        "fileDescription",
        "progressValue",
        "accessibleTextForProgress",
        "accessibleTextForSpinner",
        "skin",
        "layout",
        "errorMessage"
    ]), S = h, k = x;
    w && !S && (S = w.t('file-tile.accessible-text-for-progress', {
        progress: w.formatNumber(null != g ? g : 0, {
            style: 'unit',
            unit: 'percent'
        })
    })), w && !k && (k = w.t('file-tile.accessible-text-for-spinner'));
    let N = 'error' === P || v, D = new Set([
        'swan-file-tile',
        `swan-file-tile-skin-${N ? 'error' : P}`,
        `swan-file-tile-layout-${F}`
    ]), E = useContext(FormFieldContext);
    if (N && !E) throw Error('FileTile must be wrapped in FormField with a FileInput when using skin="error"');
    return jsxs(Card, _object_spread_props(_object_spread({
        className: Array.from(D).join(' '),
        ref: y
    }, T), {
        bordered: true,
        children: [
            jsx(Spinner, {
                className: "swan-file-tile-spinner",
                accessibleText: null != k ? k : ''
            }),
            O,
            jsxs("div", {
                className: "swan-file-tile-details",
                children: [
                    jsx(Typography, {
                        className: "swan-file-tile-name",
                        fontSkin: "title-item",
                        children: j
                    }),
                    jsx(Typography, {
                        className: "swan-file-tile-description",
                        fontSkin: "body-small",
                        textColor: "subtle",
                        children: N ? jsx(FormError, {
                            as: "div",
                            children: v
                        }) : 'queued' === P ? k : _
                    }),
                    jsx("div", {
                        className: "swan-file-tile-progress-container",
                        children: jsx(Progress, {
                            value: null != g ? g : 0,
                            "aria-label": S
                        })
                    })
                ]
            })
        ]
    }));
});

export { FileTile };
